import type { CurriculumConstraints, CurriculumPlan, OptionBlock } from '../../types';

// Mock curriculum plans with lesson requirements and constraints

export const mockCurriculumPlans: CurriculumPlan[] = [
  // Year 7 - Core subjects
  {
    id: 'plan-y7-math',
    subjectId: 'subject-math',
    yearGroupId: 'year-7',
    lessonsPerWeek: 5,
    teachingModel: 'sets',
    setCount: 4,
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: false,
    },
  },
  {
    id: 'plan-y7-english-lang',
    subjectId: 'subject-english-lang',
    yearGroupId: 'year-7',
    lessonsPerWeek: 3,
    teachingModel: 'sets',
    setCount: 4,
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: false,
    },
  },
  {
    id: 'plan-y7-english-lit',
    subjectId: 'subject-english-lit',
    yearGroupId: 'year-7',
    lessonsPerWeek: 2,
    teachingModel: 'sets',
    setCount: 4,
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: false,
    },
  },
  {
    id: 'plan-y7-science',
    subjectId: 'subject-combined-science',
    yearGroupId: 'year-7',
    lessonsPerWeek: 5,
    teachingModel: 'whole-class',
    constraints: {
      requiresDoubleLessons: true,
      doubleCount: 2,
      requiresSpecialistRoom: true,
      requiredRoomType: 'laboratory',
      isElective: false,
    },
  },

  // Year 8 - Core subjects
  {
    id: 'plan-y8-math',
    subjectId: 'subject-math',
    yearGroupId: 'year-8',
    lessonsPerWeek: 5,
    teachingModel: 'sets',
    setCount: 4,
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: false,
    },
  },
  {
    id: 'plan-y8-english-lang',
    subjectId: 'subject-english-lang',
    yearGroupId: 'year-8',
    lessonsPerWeek: 3,
    teachingModel: 'sets',
    setCount: 4,
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: false,
    },
  },
  {
    id: 'plan-y8-english-lit',
    subjectId: 'subject-english-lit',
    yearGroupId: 'year-8',
    lessonsPerWeek: 2,
    teachingModel: 'sets',
    setCount: 4,
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: false,
    },
  },
  {
    id: 'plan-y8-science',
    subjectId: 'subject-combined-science',
    yearGroupId: 'year-8',
    lessonsPerWeek: 5,
    teachingModel: 'whole-class',
    constraints: {
      requiresDoubleLessons: true,
      doubleCount: 2,
      requiresSpecialistRoom: true,
      requiredRoomType: 'laboratory',
      isElective: false,
    },
  },

  // Year 9 - GCSE preparation with options
  {
    id: 'plan-y9-math',
    subjectId: 'subject-math',
    yearGroupId: 'year-9',
    lessonsPerWeek: 5,
    teachingModel: 'sets',
    setCount: 5,
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: false,
    },
  },
  {
    id: 'plan-y9-english-lang',
    subjectId: 'subject-english-lang',
    yearGroupId: 'year-9',
    lessonsPerWeek: 3,
    teachingModel: 'sets',
    setCount: 5,
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: false,
    },
  },
  {
    id: 'plan-y9-english-lit',
    subjectId: 'subject-english-lit',
    yearGroupId: 'year-9',
    lessonsPerWeek: 2,
    teachingModel: 'sets',
    setCount: 5,
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: false,
    },
  },
  {
    id: 'plan-y9-science',
    subjectId: 'subject-combined-science',
    yearGroupId: 'year-9',
    lessonsPerWeek: 5,
    teachingModel: 'whole-class',
    constraints: {
      requiresDoubleLessons: true,
      doubleCount: 2,
      requiresSpecialistRoom: true,
      requiredRoomType: 'laboratory',
      isElective: false,
    },
  },

  // Year 9 - Option subjects
  {
    id: 'plan-y9-history',
    subjectId: 'subject-history',
    yearGroupId: 'year-9',
    lessonsPerWeek: 3,
    teachingModel: 'options',
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: true,
      optionBlock: 'option-block-y9-a',
    },
  },
  {
    id: 'plan-y9-geography',
    subjectId: 'subject-geography',
    yearGroupId: 'year-9',
    lessonsPerWeek: 3,
    teachingModel: 'options',
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: true,
      optionBlock: 'option-block-y9-a',
    },
  },
  {
    id: 'plan-y9-french',
    subjectId: 'subject-french',
    yearGroupId: 'year-9',
    lessonsPerWeek: 3,
    teachingModel: 'options',
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: true,
      optionBlock: 'option-block-y9-b',
    },
  },
  {
    id: 'plan-y9-spanish',
    subjectId: 'subject-spanish',
    yearGroupId: 'year-9',
    lessonsPerWeek: 3,
    teachingModel: 'options',
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: true,
      optionBlock: 'option-block-y9-b',
    },
  },
  {
    id: 'plan-y9-art',
    subjectId: 'subject-art',
    yearGroupId: 'year-9',
    lessonsPerWeek: 3,
    teachingModel: 'options',
    constraints: {
      requiresDoubleLessons: true,
      doubleCount: 1,
      requiresSpecialistRoom: true,
      requiredRoomType: 'art',
      isElective: true,
      optionBlock: 'option-block-y9-c',
    },
  },
  {
    id: 'plan-y9-music',
    subjectId: 'subject-music',
    yearGroupId: 'year-9',
    lessonsPerWeek: 3,
    teachingModel: 'options',
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: true,
      requiredRoomType: 'music',
      isElective: true,
      optionBlock: 'option-block-y9-c',
    },
  },
  {
    id: 'plan-y9-computer-science',
    subjectId: 'subject-computer-science',
    yearGroupId: 'year-9',
    lessonsPerWeek: 3,
    teachingModel: 'options',
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: true,
      requiredRoomType: 'ict',
      isElective: true,
      optionBlock: 'option-block-y9-d',
    },
  },
  {
    id: 'plan-y9-dt',
    subjectId: 'subject-dt',
    yearGroupId: 'year-9',
    lessonsPerWeek: 3,
    teachingModel: 'options',
    constraints: {
      requiresDoubleLessons: true,
      doubleCount: 1,
      requiresSpecialistRoom: true,
      requiredRoomType: 'dt',
      isElective: true,
      optionBlock: 'option-block-y9-d',
    },
  },

  // Year 10 & 11 - GCSE core
  {
    id: 'plan-y10-math',
    subjectId: 'subject-math',
    yearGroupId: 'year-10',
    lessonsPerWeek: 5,
    teachingModel: 'sets',
    setCount: 6,
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: false,
    },
  },
  {
    id: 'plan-y11-math',
    subjectId: 'subject-math',
    yearGroupId: 'year-11',
    lessonsPerWeek: 5,
    teachingModel: 'sets',
    setCount: 6,
    constraints: {
      requiresDoubleLessons: false,
      requiresSpecialistRoom: false,
      isElective: false,
    },
  },

  // Year 12 & 13 - A-Level
  {
    id: 'plan-y12-math-alevel',
    subjectId: 'subject-math-alevel',
    yearGroupId: 'year-12',
    lessonsPerWeek: 6,
    teachingModel: 'whole-class',
    constraints: {
      requiresDoubleLessons: true,
      doubleCount: 3,
      requiresSpecialistRoom: false,
      isElective: true,
    },
  },
  {
    id: 'plan-y13-math-alevel',
    subjectId: 'subject-math-alevel',
    yearGroupId: 'year-13',
    lessonsPerWeek: 6,
    teachingModel: 'whole-class',
    constraints: {
      requiresDoubleLessons: true,
      doubleCount: 3,
      requiresSpecialistRoom: false,
      isElective: true,
    },
  },
  {
    id: 'plan-y12-physics-alevel',
    subjectId: 'subject-physics-alevel',
    yearGroupId: 'year-12',
    lessonsPerWeek: 6,
    teachingModel: 'whole-class',
    constraints: {
      requiresDoubleLessons: true,
      doubleCount: 2,
      requiresSpecialistRoom: true,
      requiredRoomType: 'laboratory',
      isElective: true,
    },
  },
  {
    id: 'plan-y13-physics-alevel',
    subjectId: 'subject-physics-alevel',
    yearGroupId: 'year-13',
    lessonsPerWeek: 6,
    teachingModel: 'whole-class',
    constraints: {
      requiresDoubleLessons: true,
      doubleCount: 2,
      requiresSpecialistRoom: true,
      requiredRoomType: 'laboratory',
      isElective: true,
    },
  },
];

// Option blocks for Year 9 GCSE choices
export const mockOptionBlocks: OptionBlock[] = [
  {
    id: 'option-block-y9-a',
    name: 'Option Block A - Humanities',
    yearGroupId: 'year-9',
    subjects: ['subject-history', 'subject-geography', 'subject-rs'],
    simultaneous: true,
    periods: [
      { day: 'tuesday', period: 1 },
      { day: 'thursday', period: 1 },
      { day: 'friday', period: 4 },
    ],
  },
  {
    id: 'option-block-y9-b',
    name: 'Option Block B - Languages',
    yearGroupId: 'year-9',
    subjects: ['subject-french', 'subject-spanish', 'subject-german'],
    simultaneous: true,
    periods: [
      { day: 'monday', period: 2 },
      { day: 'wednesday', period: 3 },
      { day: 'friday', period: 1 },
    ],
  },
  {
    id: 'option-block-y9-c',
    name: 'Option Block C - Creative Arts',
    yearGroupId: 'year-9',
    subjects: ['subject-art', 'subject-music', 'subject-drama'],
    simultaneous: true,
    periods: [
      { day: 'tuesday', period: 4 },
      { day: 'wednesday', period: 1 },
      { day: 'thursday', period: 5 },
    ],
  },
  {
    id: 'option-block-y9-d',
    name: 'Option Block D - Technology',
    yearGroupId: 'year-9',
    subjects: ['subject-computer-science', 'subject-dt', 'subject-business'],
    simultaneous: true,
    periods: [
      { day: 'monday', period: 4 },
      { day: 'tuesday', period: 2 },
      { day: 'friday', period: 2 },
    ],
  },
];

// Helper functions
export const getCurriculumPlansByYearGroup = (yearGroupId: string): CurriculumPlan[] => {
  return mockCurriculumPlans.filter((p) => p.yearGroupId === yearGroupId);
};

export const getCurriculumPlansBySubject = (subjectId: string): CurriculumPlan[] => {
  return mockCurriculumPlans.filter((p) => p.subjectId === subjectId);
};

export const getOptionBlocksByYearGroup = (yearGroupId: string): OptionBlock[] => {
  return mockOptionBlocks.filter((b) => b.yearGroupId === yearGroupId);
};

export const getCorePlans = (): CurriculumPlan[] => {
  return mockCurriculumPlans.filter((p) => !p.constraints.isElective);
};

export const getElectivePlans = (): CurriculumPlan[] => {
  return mockCurriculumPlans.filter((p) => p.constraints.isElective);
};

export const getTotalLessonsPerWeek = (yearGroupId: string): number => {
  return getCurriculumPlansByYearGroup(yearGroupId).reduce((total, plan) => total + plan.lessonsPerWeek, 0);
};
